import { useQuery } from "@apollo/client";
import type {
  DataSourcesFastInfoResponse,
  UseIntegratedDataSourcesFastInfoResult,
} from "./types";
import { GET_THREAT_INTELLIGENCE_DATA_SOURCES_FAST_INFO } from "./APIs/ThreatIntelligenceApi";

const useThreatIntelligenceDataSourcesFastInfo = (
  useCache = false
): UseIntegratedDataSourcesFastInfoResult => {
  const {
    data: integratedDataSourcesFastInfo,
    error: integratedDataSourcesFastInfoError,
    loading: integratedDataSourcesFastInfoLoading,
  } = useQuery<DataSourcesFastInfoResponse>(
    GET_THREAT_INTELLIGENCE_DATA_SOURCES_FAST_INFO,
    {
      fetchPolicy: useCache ? "cache-first" : "no-cache",
    }
  );

  return {
    integratedDataSourcesFastInfo,
    integratedDataSourcesFastInfoError,
    integratedDataSourcesFastInfoLoading,
  };
};

export default useThreatIntelligenceDataSourcesFastInfo;
